// 吃瓜黑网 · 首页静态内容（内容主体均为虚构，仅作站内展示）

export const navLinks = [
  { id: "headline", label: "今日头版" },
  { id: "collapsed", label: "塌房现场" },
  { id: "reversal", label: "翻车实录" },
  { id: "avoidlist", label: "避雷名单" },
  { id: "heat", label: "热度榜" },
  { id: "watch", label: "争议观察" },
];

export const coverStory = {
  kicker: "头版报道 · 人物争议",
  issue: "第 214 期 · 2026.09.08",
  title: "从「行业标杆」到一夜清零：顶流温叙白如何把一手好牌打成空壳",
  dek: "代言条款留白、数据口径反复、声明三改其口。吃瓜黑网还原这场争议事件的关键节点，也回答一个更本质的问题：信任究竟是在哪一帧开始崩塌的。",
  reporter: "特稿 · 黑瓜记者",
  heat: "8.7 万热度",
  tags: ["人设风险", "合约纠纷", "声明翻车"],
  image: "https://readdy.ai/api/search-image?query=Editorial%20magazine%20cover%20concept%20of%20a%20collapsing%20luxury%20stage%20and%20fallen%20pedestal%2C%20warm%20ivory%20paper%20background%20with%20vermilion%20red%20ink%20brush%20marks%2C%20grainy%20halftone%20print%20texture%2C%20retro%20Chinese%20tabloid%20illustration%20style%2C%20dramatic%20chiaroscuro%20lighting%2C%20conceptual%20composition%2C%20high%20contrast%2C%20no%20text%2C%20no%20real%20faces&width=1600&height=1000&seq=gua-cover-01&orientation=landscape",
};

export type CollapseItem = {
  id: string;
  category: string;
  title: string;
  lead: string;
  detail: string;
  happened: string;
  risk: string;
  heat: string;
  image: string;
};

export const collapseItems: CollapseItem[] = [
  {
    id: "coll-1",
    category: "品牌 · 消费",
    title: "燕窝「青梧集」成分表被指与送检报告两本账",
    lead: "一边是直播间里「含量≥50%」的底气，一边是第三方检测仅 12.6% 的留样。",
    detail: "塌房现场：多名经销商晒出同一批次留样，声称与宣传页明显不符，品牌客服连夜把详情页下架修改，声明却迟迟未落款盖章。",
    happened: "2026.09.06",
    risk: "虚假宣传",
    heat: "热度 5.1 万",
    image: "https://readdy.ai/api/search-image?query=Conceptual%20editorial%20illustration%20of%20a%20glass%20jar%20of%20collagen%20tonic%20casting%20a%20long%20shadow%20beside%20a%20magnifying%20glass%2C%20warm%20ivory%20paper%20background%2C%20vermilion%20and%20amber%20ink%20palette%2C%20grainy%20print%20texture%2C%20retro%20tabloid%20style%2C%20high%20contrast%2C%20no%20text&width=900&height=700&seq=gua-coll-01&orientation=landscape",
  },
  {
    id: "coll-2",
    category: "人物 · 带货",
    title: "头部主播「阿澈」售后群集体失声，超 2 万人排队退款",
    lead: "下单时喊你「家人们」，出事后拉黑退换通道。",
    detail: "塌房现场持续发酵：粉丝维权群截图流出，客服机器人循环同一段话术。平台已介入，品牌方却称「仅系沟通环节拥堵」。",
    happened: "2026.09.07",
    risk: "售后失联",
    heat: "热度 6.8 万",
    image: "https://readdy.ai/api/search-image?query=Editorial%20concept%20of%20a%20live%20streaming%20microphone%20shattered%20into%20pieces%20on%20warm%20ivory%20paper%2C%20scattered%20amber%20and%20vermilion%20ink%20splashes%2C%20grainy%20halftone%20print%2C%20retro%20Chinese%20tabloid%20illustration%2C%20dramatic%20shadow%2C%20no%20text%2C%20no%20real%20faces&width=900&height=700&seq=gua-coll-02&orientation=landscape",
  },
  {
    id: "coll-3",
    category: "餐饮 · 连锁",
    title: "网红连锁「辣小厨」后厨画面曝光，门店连夜换招牌",
    lead: "排队的队伍有多长，后厨的边角料就有多惊心。",
    detail: "争议事件现场实录：内场视频流出后，涉事门店当日排队叫号量不降反升，被网友讥为「边塌边开张」。总部声明称已无限期停业整改。",
    happened: "2026.09.05",
    risk: "食安卫生",
    heat: "热度 4.6 万",
    image: "https://readdy.ai/api/search-image?query=Conceptual%20editorial%20illustration%20of%20a%20closed%20restaurant%20storefront%20with%20a%20flipped%20signboard%20and%20yellow%20caution%20tape%2C%20warm%20ivory%20and%20amber%20palette%2C%20grainy%20print%20texture%2C%20retro%20tabloid%20style%2C%20dramatic%20lighting%2C%20no%20text%2C%20no%20real%20people&width=900&height=700&seq=gua-coll-03&orientation=landscape",
  },
];

export type ReversalItem = {
  id: string;
  order: string;
  subject: string;
  subtitle: string;
  stages: string[];
  lesson: string;
  image: string;
};

export const reversalItems: ReversalItem[] = [
  {
    id: "rev-1",
    order: "01",
    subject: "美妆「澜霓」：从国货之光到被逐出仓库",
    subtitle: "一部 14 个月的高光与崩塌复盘",
    stages: ["高光期：三个月霸榜细分第一", "扩量期：为冲销量放低质检口径", "爆雷点：抽检不合格登上通报", "收尾期：联名方集体解约、产品下架"],
    lesson: "复盘结论：翻车从来不是「一夜之间」，而是每一道被放行的次品垒成的高墙。",
    image: "https://readdy.ai/api/search-image?query=Editorial%20concept%20of%20luxury%20makeup%20bottles%20tumbling%20off%20a%20shelf%20into%20shadow%2C%20warm%20ivory%20paper%20background%2C%20vermilion%20and%20rose%20ink%20accents%2C%20grainy%20halftone%20print%2C%20retro%20tabloid%20style%2C%20dramatic%20chiaroscuro%2C%20no%20text%2C%20no%20brand%20logos&width=900&height=620&seq=gua-rev-01&orientation=landscape",
  },
  {
    id: "rev-2",
    order: "02",
    subject: "地产商「杉垣」：烂尾楼前的最后一场烟火秀",
    subtitle: "一边高调开盘，一边账上只剩 40 天粮草",
    stages: ["造势期：请来名流剪彩、满城广告", "激进期：用预售金做下一块地皮的保证金", "崩盘点：资金链断裂，工地静默", "追责期：业主维权，法人被限高"],
    lesson: "复盘结论：华丽的舞台能遮住裂缝，却遮不住交付日那面空墙。",
    image: "https://readdy.ai/api/search-image?query=Editorial%20concept%20of%20an%20unfinished%20concrete%20building%20scaffolding%20against%20warm%20sunset%20paper%20tone%2C%20amber%20and%20deep%20ink%20palette%2C%20grainy%20print%20texture%2C%20retro%20tabloid%20illustration%2C%20dramatic%20silhouette%2C%20no%20text%2C%20no%20real%20people&width=900&height=620&seq=gua-rev-02&orientation=landscape",
  },
  {
    id: "rev-3",
    order: "03",
    subject: "网红「江也」：道歉信怎么写才能越道歉越翻车",
    subtitle: "一次不真诚声明引发的二次塌房样本",
    stages: ["原点：一篇夸大其词的使用体验分享", "回应：删帖并含糊其辞", "翻车：被挖出旧账号真相反转", "终局：全网下架、暂停直播"],
    lesson: "复盘结论：避雷名单上最长的队伍，往往是从一句不诚恳的「对不起」开始排的。",
    image: "https://readdy.ai/api/search-image?query=Editorial%20concept%20of%20a%20crumpled%20apology%20letter%20with%20red%20ink%20crosses%20and%20a%20broken%20megaphone%2C%20warm%20ivory%20paper%20background%2C%20vermilion%20accent%2C%20grainy%20print%2C%20retro%20tabloid%20style%2C%20high%20contrast%2C%20no%20text%2C%20no%20real%20faces&width=900&height=620&seq=gua-rev-03&orientation=landscape",
  },
];

export type AvoidItem = {
  id: string;
  name: string;
  field: string;
  reason: string;
  level: "红" | "橙" | "黄";
  tags: string[];
  updated: string;
};

export const avoidItems: AvoidItem[] = [
  { id: "av-1", name: "澜霓美妆", field: "护肤彩妆", reason: "抽检通报、退换沟通不畅", level: "红", tags: ["质量通报", "售后"], updated: "今日更新" },
  { id: "av-2", name: "杉垣置地", field: "地产置业", reason: "资金链疑云、交付延期", level: "红", tags: ["烂尾风险", "交付"], updated: "2 天前" },
  { id: "av-3", name: "辣小厨", field: "餐饮连锁", reason: "后厨卫生、整改反复", level: "橙", tags: ["食安", "卫生"], updated: "今日更新" },
  { id: "av-4", name: "阿澈严选", field: "直播带货", reason: "售后失联、话术僵化", level: "橙", tags: ["售后", "退款"], updated: "1 天前" },
  { id: "av-5", name: "青梧集", field: "滋补食品", reason: "成分与宣传存疑", level: "黄", tags: ["成分存疑"], updated: "3 天前" },
  { id: "av-6", name: "拾光旅社", field: "旅游出行", reason: "退改政策不明、宣传夸大", level: "黄", tags: ["退改", "夸大"], updated: "本周" },
];

export type HeatItem = {
  id: string;
  rank: number;
  keyword: string;
  tag: string;
  heat: string;
  delta: "up" | "down" | "flat";
  ratio: number;
};

export const heatItems: HeatItem[] = [
  { id: "h1", rank: 1, keyword: "温叙白声明三改", tag: "人物争议", heat: "热度 28.4 万", delta: "up", ratio: 100 },
  { id: "h2", rank: 2, keyword: "青梧集下架风波", tag: "品牌消费", heat: "热度 21.9 万", delta: "up", ratio: 88 },
  { id: "h3", rank: 3, keyword: "辣小厨后厨画面", tag: "餐饮食安", heat: "热度 17.3 万", delta: "flat", ratio: 74 },
  { id: "h4", rank: 4, keyword: "阿澈退款长队", tag: "直播带货", heat: "热度 12.6 万", delta: "down", ratio: 60 },
  { id: "h5", rank: 5, keyword: "某综艺选手退赛", tag: "文娱现场", heat: "热度 9.8 万", delta: "up", ratio: 47 },
  { id: "h6", rank: 6, keyword: "联名翻车盘点", tag: "品牌观察", heat: "热度 7.2 万", delta: "flat", ratio: 36 },
];

export const watchStory = {
  kicker: "争议观察 · 专栏手记",
  title: "塌房从不随机：被反复踩中的三条裂缝",
  lead: "我们在避雷名单与翻车实录里划到第 214 期，发现绝大多数争议事件，其实都倒在同一个地方。",
  points: [
    { k: "裂缝一", t: "把「话术」当「承诺」，把预售当成交" },
    { k: "裂缝二", t: "危机第一反应是删，而不是面对" },
    { k: "裂缝三", t: "把粉丝的信任当成无限透支的额度" },
  ],
  quote: "吃瓜图一时热闹，但避雷名单的目的，是让下一颗雷塌之前，先被你看见。",
  image: "https://readdy.ai/api/search-image?query=Editorial%20magazine%20feature%20concept%20of%20three%20cracks%20running%20through%20a%20cream%20paper%20ground%20with%20vermilion%20ink%20sealing%20stamps%2C%20warm%20ivory%20and%20amber%20palette%2C%20grainy%20halftone%20print%2C%20retro%20Chinese%20tabloid%20style%2C%20dramatic%20lighting%2C%20no%20text&width=1200&height=820&seq=gua-watch-01&orientation=landscape",
};

export const noticeHighlights = [
  { label: "累计收录", value: "314 期" },
  { label: "跟踪避雷对象", value: "87 个" },
  { label: "核实争议事件", value: "612 起" },
];